import React, { createContext, useContext, useMemo } from 'react';
const ActionContext = createContext({});
export const useConfig = () => useContext(ActionContext);
/** Provide action events, passed from the app. Used for analytics. */
export default ({ children, actionHandlers }) => {
    const value = useMemo(() => actionHandlers, [actionHandlers]);
    return React.createElement(ActionContext.Provider, { value: value }, children);
};
/** Use action events, passed from the app. Used for analytics. */
export const useActionEvents = () => useContext(ActionContext);
//# sourceMappingURL=ActionProvider.js.map